module.exports = __webpack_public_path__ + "img/item-6(1920).1a4ac909.jpg";